import React from 'react';

// This hash is substituted in the "build all" step in .gitlab-ci.yml
const VERSION = '13310788';
export const ZINNIA_STYLESHEET_URL = `https://design-system-css.zapier.com/design-system/${VERSION}.css`;

export const ZinniaStylesheet = (
  props: React.HTMLAttributes<HTMLLinkElement>
) => {
  return <link href={ZINNIA_STYLESHEET_URL} rel="stylesheet" {...props} />;
};
